// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {CSSProperties, Fragment, useContext,
  useEffect, useRef, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../lib/button';
import styles from './review.module.less';
import {img_url} from '../ui/img_url';
import Chevron_left from '../img/hola2023/icons/16/chevron_left.svg';
import Chevron_right from '../img/hola2023/icons/16/chevron_right.svg';
import {use_screen} from '../lib/screen_util';
import {App_context} from 'hola_app_context';

interface i_review {
    rating?: boolean
    description: string;
    author: string;
}
interface i_store_review_props {
    store_img: string;
    store: string;
    title: string;
    rating?: string;
    footer?: string;
    footer_higlight?: string;
    reviews?: i_review[];
}

export const Store_review = (props: i_store_review_props)=>{
    const {title, store, store_img, rating, footer, footer_higlight,
        reviews = []} = props;
    const {theme} = useContext(Settings_context);
    const {is_client} = useContext(App_context);
    const {width} = use_screen();
    const container_ref = useRef(null);
    const scroll_left = ()=>{
        const container = container_ref.current;
        const scroll_amount = 343 + 24;

        if (container.scrollLeft == 0)
            container.scrollLeft = container.scrollWidth;

        container.scrollBy({left: -scroll_amount, behavior: 'smooth'});
    };
    const scroll_right = ()=>{
        const container = container_ref.current;
        const gap = 24;
        const scroll_amount = 343 + gap;

        const scroll_width = container.scrollWidth - gap;
        if (container.scrollLeft + container.offsetWidth >= scroll_width)
          container.scrollLeft = 0;

        container.scrollBy({left: scroll_amount, behavior: 'smooth'});
    };

    const duplicated_children = Array.isArray(reviews) && is_client
      && width > 768 ? [...reviews, ...reviews] : reviews;
    const grid_number = {
      '--grid_number': duplicated_children.length ?
        Array(duplicated_children.length).fill('auto').join(' ') : 'auto'
    } as CSSProperties;
    return <div className={cn(styles.reviews_container)}>
      <div className={styles.store_container}>
        <div className={styles.rating_wrapper}>
          <img className={cn('lazyload', styles.store_img)}
            src={store_img} alt="store image" />
          <p className={cn(theme.color_n800, theme.p1)}>{store}</p>
          </div>
        <div className={styles.rating_wrapper}>
          {rating && <Fragment>
            <div className={styles.separator}>&nbsp;</div>
            <div className={styles.rating}>
                <img className={styles.stars}
                  src={img_url('hola2023/star.svg')} alt="stars"/>
            </div>
            <p className={cn(theme.p1, theme.med, theme.color_n600)}>
              {rating}
            </p>
          </Fragment>}
          </div>
      </div>
      <p className={cn(theme.H3, theme.color_n700, styles.reviews_title)}>
        {title}</p>
      <div className={styles.carousel_wrapper}>
        <div className={styles.carousel_left_btn_wrapper}>
          <button onClick={scroll_left}
            className={styles.carousel_left_btn}><Chevron_left /></button>
        </div>
        <div className={styles.review_container} style={grid_number}
          ref={container_ref}>
            {duplicated_children && duplicated_children.map((r, i)=>
              <div className={styles.review} key={i}>
              {r.rating &&
              <img className={cn('lazyload', styles.review_rating)}
                src={img_url('hola2023/android_review_stars.png')}
                alt="reviews"/>}
              <p className={cn(theme.p2, theme.reg, theme.color_n700)}>
                {r.description}</p>
              <p className={cn(theme.u4, theme.color_n500)}>{r.author}</p>
              </div>)}</div>
        <div className={styles.carousel_right_btn_wrapper}>
          <button onClick={scroll_right}
            className={styles.carousel_right_btn}><Chevron_right /></button>
          </div></div>
      <p className={cn(theme.p1, theme.med, theme.color_n700, styles.footer)}>
        {footer}{footer_higlight && <span>{footer_higlight}</span>}</p>
      </div>;
};

interface i_store_review_editor {
    value: i_store_review_props;
    on_change: (new_value: i_store_review_props)=>void;
    on_cancel: ()=>void;
}

export const Store_review_editor = (props: i_store_review_editor)=>{
    const [state, set_state] = useState<i_store_review_props>(()=>({
      store_img: props.value?.store_img || '',
      store: props.value?.store || '',
      title: props.value?.title || '',
      rating: props.value?.rating || '',
      footer: props.value?.footer || '',
      reviews: props.value?.reviews || [],
    }));
    const reviews = state.reviews || [];
    useEffect(()=>{
        set_state(c=>({...c, ...props.value}));
    }, [props.value]);
    return <Editor
      value={state}
      editors={[{key: 'store_img', label: 'Store logo', type: 'text'},
        {key: 'store', label: 'Store Name', type: 'text'},
        {key: 'title', label: 'Title', type: 'text'},
        {key: 'rating', label: 'Rating', type: 'text'},
        {key: 'footer', label: 'Footer text', type: 'text'},
        {key: 'footer_higlight', label: 'Footer Highlight', type: 'text'}]}
      on_change={v=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}>
      <h4>Reviews: </h4>
      {reviews.map((li, i)=>
        <Fragment key={i}>
          <Editor
            title={li.author || `unknown`}
            key={i}
            value={li}
            editors={[
              {key: 'rating', label: 'Rating', type: 'boolean'},
              {key: 'description', label: 'Review', type: 'textarea'},
              {key: 'author', label: 'Author', type: 'text'},
            ]}
            on_change={v=>{
              const items_new = [...reviews];
              items_new[i] = v;
              set_state({...state, reviews: items_new});
            }}>
          </Editor>
          <Button caption={'Delete feature'} size={'xs'}
            on_click={()=>{
              set_state({...state, reviews: reviews
                .filter((_, index)=>index!==i)});
            }}/>
        </Fragment>
      )}
      <Button caption={'Add review'} size={'xs'}
        on_click={()=>{
          set_state({...state, reviews: [...reviews, {
            rating: false,
            description: '',
            author: '',
          }]});
        }}/>
    </Editor>;
};
